import { render, staticRenderFns } from "./ObjectOfferHeader.vue?vue&type=template&id=5fbca401"
import script from "./ObjectOfferHeader.vue?vue&type=script&lang=js"
export * from "./ObjectOfferHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports